import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-cycle
import { authStore } from './auth';

// eslint-disable-next-line import/prefer-default-export
export const useApplicationStore = defineStore('application', {
  state: () => ({
    appLoadComplete: false,
    appLoading: false,
  }),
  actions: {
    async appLoad() {
      this.appLoading = true;
      const store = authStore();
      return store.fetchUser().then(() => {
        this.appLoadComplete = true;
        this.appLoading = false;
      });
    },
  },
});
